import { useMap } from '@vis.gl/react-google-maps';
import React, { useEffect, useRef } from 'react';
import { PolygonWithZone, Zone } from '../interface';
import { useDispatch } from 'react-redux';

interface MapPolygonProps {
  zones: Zone[];
  onPolygonsCreated?: (polygons: PolygonWithZone[]) => void;
  onPolygonClick?: (zone: Zone) => void;
}

const MapPolygon: React.FC<MapPolygonProps> = ({ zones, onPolygonsCreated, onPolygonClick }) => {
  const map = useMap();

  const polygonsRef = useRef<PolygonWithZone[]>([]);
  const infoWindowRef = useRef<google.maps.InfoWindow | null>(null);

  // Clean up function to remove polygons
  const cleanupPolygons = () => {
    polygonsRef.current.forEach(({ polygon }) => {
      polygon.setMap(null); // Remove from map
      google.maps.event.clearInstanceListeners(polygon); // Clean up listeners
    });
    polygonsRef.current = [];
  };

  const showInfoWindow = (event: google.maps.MapMouseEvent, zone: Zone) => {
    const infoWindow = infoWindowRef.current;
    if (!infoWindow) return;

    const contentString = `
            <div style="margin-top: -10px;">
                <p style="color: ${zone.zoneColor};"><strong>${zone.zoneName}</strong></p>
            </div>
        `;
    //infoWindow.setHeaderContent(`Zone: ${zone.zoneName + '   '}`);
    infoWindow.setContent(contentString);
    infoWindow.setPosition(event.latLng);

    infoWindow.open(map);
    if (onPolygonClick) {
      onPolygonClick(zone);
    }
  };

  useEffect(() => {
    if (!map || !zones) return;

    // Create info window once
    if (!infoWindowRef.current) {
      infoWindowRef.current = new google.maps.InfoWindow();
    }

    cleanupPolygons();

    polygonsRef.current = [];
    if (zones) {
      zones.forEach((zone) => {
        const polygon = new google.maps.Polygon({
          paths: zone?.coordinates,
          strokeColor: zone.zoneColor,
          strokeOpacity: 0.7,
          strokeWeight: 1,
          fillColor: zone.zoneColor,
          fillOpacity: 0.4,
        });

        polygon.setMap(map);
        polygonsRef.current.push({ zone, polygon });
        // add event
        polygon.addListener('click', (event: google.maps.MapMouseEvent) => {
          showInfoWindow(event, zone);
        });
      });
      //dispatch(setPolygonsWithZones(polygonsRef.current));
      // if (polygonsWithZones) {
      //   onPolygonsCreated(polygonsRef.current);
      // }
    }
    // Cleanup on unmount or when zones change
    return cleanupPolygons;
  }, [map, zones]);

  return null;
};

export default React.memo(MapPolygon);
